import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'inscricoes-modal-pendencias-classificacao',
  templateUrl: './modal-pendencias-classificacao.component.html',
  styleUrls: ['./modal-pendencias-classificacao.component.scss']
})
export class ModalPendenciasClassificacaoComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalPendenciasClassificacaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      examinadoresSemMalote: string[];
      examinadoresComNotasEmpatadas: string[];
    }
  ) {}

  fechar(): void {
    this.dialogRef.close();
  }
}
